import { render, staticRenderFns } from "./recipeCard.vue?vue&type=template&id=0502227c&"
import script from "./recipeCard.vue?vue&type=script&lang=js&"
export * from "./recipeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports